<template>
    <div class="tl video-tree">
        <template>
            <el-tabs  @tab-click="handleClick" >
                <el-tab-pane label="基本信息" style="overflow-x: auto">
                    <div v-if="tabIndex == 0">
                        <basic-information :formvalue="formvalue" v-if="i_type!=-1" @proDetails="proDetails"></basic-information>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="班次明细" >
                    <div v-if="tabIndex == 1&&i_type!=0">
                        <shift-details  :formvalue="formvalue" v-if="i_type!=-1" ref="shiftdetails"></shift-details>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="考勤人员" class="tabWidth">
                    <div v-if="tabIndex == 2&&i_type!=0">
                        <attendance-pers :formvalue="formvalue" v-if="i_type!=-1" ref="attendancepers"></attendance-pers>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="假别" class="tabWidth">
                    <div v-if="tabIndex == 3&&i_type!=0">
                        <jia-qin :formvalue="formvalue" v-if="i_type!=-1" ref="jiaQin"></jia-qin>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="节假日" class="tabWidth">
                    <div v-if="tabIndex == 4&&i_type!=0">
                        <jie-jia-ri :formvalue="formvalue" v-if="i_type!=-1" ref="jieJiaRi"></jie-jia-ri>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </template>
    </div>
</template>

<script>
    import * as API from "../api"

    import shiftDetails from "./shiftDetails/ShiftDetails";
    import BasicInformation from "./BasicInformation/BasicInformation";
    import AttendancePers from "./AttendancePers/AttendancePers";
    import jiaQin from "./jiaqin/JiaQin";
    import jieJiaRi from "./jiejiari/JieJiaRi";

    export default {
        name: "TabsList",
        components: {
            AttendancePers,
            BasicInformation,
            shiftDetails,
            jiaQin,
            jieJiaRi,

        },
        props:{
            tabslist:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                show:false,
                formvalue:{},
                tabIndex:0,
                i_type:-1,
                i_show:1,
            }
        },
        watch:{
            tabslist(){
                if (this.tabslist){
                    this.i_type=this.tabslist.i_id;
                    this.i_show=this.tabslist.i_show;
                    this.formvalue=this.tabslist;
                    // console.log(this.tabslist,"this.formvalue111");

                }
            },
            immediate:true,
            deep:true
        },
        mounted() {

        },
        methods: {
            handleClick(tab){
                //console.log("tab",tab);
                this.tabIndex = tab.index;
                //if (this.tabIndex==0){
                    // this.getEntrustCompanyHaveList();
                //}
                // else if(this.tabIndex==1){
                //     this.$refs.forChildren.getPickingReqList() //父组件调子组件
                // }
            },

            proDetails(val){
                this.$emit('refreshTask',val);
                // console.log("proDetails")
            },
            /*entrustDetails(){
                console.log("entrustDetails")
            }*/
        },
    }
</script>

<style lang="scss" scoped>
    .el-tabs{
        height:calc(100% - 5px) !important;
        /*height: 95%;*/
        /*max-height: calc(80vh);
        min-height: calc(40vh);*/
        //min-height: calc(90vh - 180px)
    }
/*.tabWidth{
    min-width: 960px;
}*/

   /* @media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 370px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 500px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 460px;
        }
    }*/

    //实现滚动功能
    .video-tree {
        overflow-y: auto;
/*padding-left: 20px;*/
    }
    /deep/{
        .el-tabs__nav-wrap::after{
            background-color: white;
        }
        .el-tabs__item.is-active{
            font-weight: bold;
            color: black;
            /*border-bottom:1px solid orange ;*/
        }
        .el-tabs__active-bar{
            background-color: orange;
        }
        .el-tabs__nav-scroll{
            background-color: rgb(255,255,255);margin-bottom: 5px;
            /*padding:10px 20px !important;*/
            /*background-color: rgb(241,241,241);*/
        }
        .el-tabs__nav-wrap{
            overflow: visible;
        }
    }
    /deep/{
        .el-tabs__item{
            height: 32px;
            line-height: 32px;
        }
        .el-tabs__nav-next, .el-tabs__nav-prev{
            line-height: 32px;
        }
    }

</style>